import { normalizeRepeater } from './events-repeater-normalize-value';
export const eventsRepeaterViewer = {
    normalizeLoadedValue: normalizeRepeater
};

//# sourceMappingURL=definition-viewer.js.map